import ImageAsset from "../Components/ImageAsset";
import CardAsset from "./CardAsset";
import Card from "./CardAsset";
import CardBack from "./CardBack";

function BlackjackCards(props: { cards: any[], label: { hi: number, lo: number }, owner: string }) {

    if (!props.cards) {
        return <></>;
    }

    if (props.cards) {
      const audio = new Audio('BlackJack RPG_Card Land SFX_20.10.2023.mp3');
      audio.play();
    }

    const label = props?.label?.hi > 21 && props?.label?.lo !== 21
        ? 'b'
        : props?.label.hi === props.label.lo
            ? props.label.hi
            : `${props.label.lo}/${props.label.hi}`;

    return (
        <div className="blackjack-cards">

            <div className="blackjack-cards_cards">
                {props.cards.map((card, index) => <div key={index} className={props.owner === "player" ? "blackjack-cards_cards_stack" : null}>
                    <CardAsset card={card} />
                </div>)}

                {props.cards && props.owner !== "player" && props.cards.length === 1 && <div className={props.owner === "player" ? "blackjack-cards_cards_stack" : null}>
                    <CardBack />
                </div>}
            </div>

            <div className="blackjack-cards_label">{label}</div>

        </div>
    )


}

export default BlackjackCards;
